import { render, staticRenderFns } from "./JobPreferences.vue?vue&type=template&id=ddb8e6f0&scoped=true&"
import script from "./JobPreferences.vue?vue&type=script&lang=ts&"
export * from "./JobPreferences.vue?vue&type=script&lang=ts&"
import style0 from "./JobPreferences.vue?vue&type=style&index=0&id=ddb8e6f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb8e6f0",
  null
  
)

export default component.exports